import { Button, Modal, Table } from "antd";
import { FaEye } from "react-icons/fa";
import React, { useState } from "react";
import dayjs from "dayjs";
import MemberProfilePopup from "../../pos/components/MemberProfilePopup";
import ModalLogComponent from "./modalLog.component";

const TableComponent = ({ callComplete, ...props }) => {
  const { confirm } = Modal;
  const [showProfile, setShowProfile] = useState(false);
  const [profileData, setProfileData] = useState();
  const [showLog, setShowLog] = useState(false);
  const [log, setLog] = useState();
  const columns = [
    {
      title: "#",
      key: "row",
      dataIndex: "row",
      align: "center",
    },
    {
      title: "วันที่ติดต่อ",
      key: "create_date",
      dataIndex: "create_date",
      width: 110,
      align: "center",
      render: (text) => <>{dayjs(text).format("DD-MM-YYYY")}</>,
    },
    {
      title: "สถานะคำขอ",
      key: "status",
      dataIndex: "status",
      width: 110,
      align: "center",
    },
    {
      title: "รหัสสมาชิก",
      key: "partner_code",
      dataIndex: "partner_code",
      align: "center",
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "full_name",
      dataIndex: "full_name",
      width: 200,
      align: "center",
    },
    {
      title: "ชื่อเล่น",
      key: "nick_name",
      dataIndex: "nick_name",
      width: 150,
      align: "center",
      render: (text) => <>{text || "-"}</>,
    },
    {
      title: "MP Rank",
      key: "name",
      dataIndex: "name",
      width: 100,
      align: "center",
    },
    {
      title: "ช่องทางติดต่อกลับ",
      key: "contact_type",
      dataIndex: "contact_type",
      align: "center",
    },
    {
      title: "ดูข้อมูลนธก.",
      align: "center",
      render: (_, record) => (
        <Button
          type="link"
          size="small"
          className="p-0 ml-2"
          onClick={() => {
            setProfileData(record);
            setShowProfile(true);
          }}
        >
          <span className="d-flex align-items-center bg-pv p-4 text-white rounded-circle">
            <FaEye />
          </span>
        </Button>
      ),
    },
    {
      title: "จำนวนคำขอ",
      key: "request_count",
      dataIndex: "request_count",
      align: "center",
    },
    {
      title: "คอมเมนท์",
      align: "center",
      width: 100,
      render: (_, record) => (
        <Button
          ghost
          style={{ color: "#00b4ac", borderColor: "#00b4ac" }}
          size="small"
          onClick={() => {
            setLog(record.log);
            setShowLog(true);
          }}
        >
          ดูคอมเมนท์
        </Button>
      ),
    },
    {
      title: "",
      align: "center",
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          disabled={record.status === "ติดต่อแล้ว"}
          onClick={() => {
            confirm({
              title:
                "ยืนยันการติดต่อกลับนักธุรกิจเรียบร้อยแล้วเพื่อปิดเคสนี้ ?",
              okText: "ยืนยัน",
              cancelText: "ยกเลิก",
              onOk() {
                return callComplete(record.id);
              },
              onCancel() {},
            });
          }}
        >
          ติดต่อแล้ว
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} bordered {...props} />
      <MemberProfilePopup
        visible={showProfile}
        setVisible={setShowProfile}
        partnerCode={profileData?.partner_code}
        refId={profileData?.member_id}
        refType={profileData?.member_type}
      />
      <ModalLogComponent visible={showLog} setVisible={setShowLog} log={log} />
    </>
  );
};

export default TableComponent;
